import React, { useState, useEffect, useRef } from "react";
import "./Header.css";
import Ctx from "./ctx";
import me from "../../assets/images/hero3.png";
import HeaderSocial from "./HeaderSocial";

const Header = () => {
  const [text, setText] = useState("Software Developer");
  const descriptors = [
    "Software Developer",
    "Flutter Developer",
    "Web Developer",
  ];
  let index = 0;

  useEffect(() => {
    const interval = setInterval(() => {
      setText(descriptors[index]);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      index = (index + 1) % descriptors.length;
    }, 1000); // Change the duration (in milliseconds) as desired

    return () => clearInterval(interval);
  }, []);

  const nameRef = useRef(null);

  useEffect(() => {
    const animateName = () => {
      const name = nameRef.current;
      const letters = name.textContent.split("");

      name.textContent = "";

      letters.forEach((letter, index) => {
        const span = document.createElement("span");
        span.textContent = letter;
        span.style.animationDelay = `${index * 0.1}s`;
        if (letter === " ") {
          span.style.marginRight = "0.5rem";
        } else {
          span.style.marginRight = "0.2rem";
        }
        name.append(span);
      });
    };

    const interval = setInterval(() => {
      animateName();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <header>
      <section className="container header__container" id="#">
        <h3>Hello I'm</h3>
        <h1 className="name-animation" ref={nameRef}>
          Mayank Kumar Shah
        </h1>
        <h3 className="text-align text-slide">
          <span>{text}</span>
        </h3>
        <Ctx />
        <HeaderSocial />
        <div className="me">
          <img src={me} alt="me" className="my-image" />
        </div>

        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </section>
    </header>
  );
};

export default Header;
